export default import.meta.ROLLUP_FILE_URL_g8n42q2ni2xZT_f1BSq69Q